import React, { useEffect, useState } from 'react';
import { Redirect, Route, } from 'react-router-dom';

import useAuth from '../auth/useAuth';
import { getError, getLanguageObj, getResponse, isUndNullEmpNew, sendMessageNew, settings } from '../helpers/UtilsHelper';
import { GlobalFormats } from '../classes/main/globalFormatClass';

const { app } = settings;
const { urls } = app?.backend;

const currentMethod = 'PublicRoute - function';

export default function PublicRoute({
    component: Component,
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
    ...rest
}) {
    //#region variables
    const auth = useAuth();
    const [isUserLoged, setIsUserLoged] = useState(auth?.isLoged());
    //#endregion variables

    //#region methods
    const checkUrlPath = ({
        url = '',
        subMethod = '',
    }) => {
        const currentMethod = 'checkUrlPath';
        let response = getResponse({ type: 0 });
        try {
            const urls_ = [
                urls?.login,
                urls?.forgotPassword,
                urls?.registerNewUser,
                urls?.registerStatus,
            ];

            response.result = urls_.some(urlSome => urlSome === url);
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
            sendMessageNew({
                msgType: response?.msgType,
                msgText: response?.msgText,
                timer: 0,
                confirmButton: true,
                timerProgressBar: false,
                languageId: languageObj?.id,
            });
            response.result = false;
        }

        return response;
    }

    const getData = () => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmpNew({ data: auth?.account?.tokenVzLaML?.token, subMethod: currentMethod, })?.result) {
                setIsUserLoged(false);
            }
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: '' });
            sendMessageNew({
                msgType: response?.msgType,
                msgText: response?.msgText,
                timer: 0,
                confirmButton: true,
                timerProgressBar: false,
                languageId: languageObj?.id,
            });
        }
    }

    useEffect(() => {
        getData();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Route {...rest}>
            {/* {!auth.isLoged() ? (<Component />) : (<Redirect to={urls?.home} />)} */}
            {
                // // auth.isLoged() ? (<Component />) :
                // //     !auth.isLoged() && rest?.path === urls?.login ? (<Component />) : (<Redirect to={urls?.home} />)
                // // isUserLoged ? (<Component />) :
                // //     !isUserLoged && rest?.path === urls?.login ? (<Component />) : (<Redirect to={urls?.home} />)

                // isUserLoged && rest?.path === urls?.login ? (<Redirect to={urls?.home} />) :
                //     !isUserLoged && rest?.path === urls?.login ? (<Component />) : (<Redirect to={urls?.home} />)

                isUserLoged && checkUrlPath({ url: rest?.path, subMethod: currentMethod, })?.result ? (<Redirect to={urls?.home} />) :
                    !isUserLoged && checkUrlPath({ url: rest?.path, subMethod: currentMethod, })?.result ? (<Component />) : (<Redirect to={urls?.home} />)
            }
        </Route>
    )
}